import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import AllMergersAcquisition from "./AllBuyProducts/AllMergersAcquisition";
import FilterAll from "../FilterAll/FilterAll";
import { useDispatch, useSelector } from "react-redux";
import { getFilter } from "../../../../redux/filter/action";
import OTSSearch from "../../../Common/Search/OTSSearch";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import classnames from "classnames";
import { Nav, NavItem, NavLink } from "reactstrap";
import { FilterMergerListings } from "../../../../redux/mergers/action";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import TranslatedText from "../../../Common/TranslatedText";
import { getPostStingName } from "../../../../assests/extention/commonfunction";

export default function SearchMergersAcquisitions() {
  const {
    state,
    setSearch,
    setProposed,
    setViewed,
    setWishlist,
    setListNull,
    setRerender,
    setAllpostfiltertab,
  } = useAllFilterBaseContext();
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const { setOTSroute } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  const dispatch = useDispatch();
  const { pageNumber } = state;
  const size = 15;

  const [activeTab, setActiveTab] = useState(
    "allpost" || state?.allpostfiltertab
  );

  useEffect(() => {
    dispatch(getFilter(8));
  }, []);

  const getallmerger = useSelector(
    ({ mergers: { getfilterdmergers } }) => getfilterdmergers
  );

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setAllpostfiltertab(tab);
      setRerender();

      switch (tab) {
        case "allpost":
          setListNull();
          break;
        case "recentview":
          setViewed();
          break;
        case "savepost":
          setWishlist();
          break;
        case "appliedpost":
          setProposed();
          break;
        default:
          break;
      }
    }
  };

  const data = {
    method: "GET",
    index: pageNumber,
    search: state?.search,
    size: size,
    proposed: state.proposed,
    viewed: String(state.viewed),
    wishlist: String(state.wishlist),
    filter: [
      {
        id: "45",
        title: "Country",
        values: state?.countries,
      },
      {
        id: "47",
        title: "cities",
        value: state?.cities,
      },
      {
        id: "46",
        title: "sort by",
        values: state?.sortByTime,
      },
      {
        id: "44",
        title: "Industry",
        filter_type: "5",
        values: state?.industries,
      },
    ],
  };

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(FilterMergerListings(data));
  }, [state]);

  return (
    <div className="project-section searchbuy">
      <div className="col-md-12 project1">
        <div className="col-md-6 mx-auto">
          <h2 className="font-42"><TranslatedText i18nKey="MAS1" /></h2>
          <div className="search-bar">
            <OTSSearch
              state={state}
              setSearch={setSearch}
              placeholder={`Search ${getPostStingName("8")}`}
            />
          </div>
          <p>Have a company? Let’s get it listed</p>
          <button
            onClick={() => { navigate(`/${lan}/dashboard/myotsproducts`); setOTSroute('MergersAcquisitions'); }}
            className="btn post-btn"
          >
            Add Company
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/plus.svg`}
              alt=""
            />
          </button>
        </div>
      </div>
      <div className="col-lg-10 mx-auto tab-sec packaged-tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "allpost" })}
              onClick={() => {
                toggle("allpost");
              }}
            >
              All Companies ({getallmerger?.count?.count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "recentview" })}
              onClick={() => {
                toggle("recentview");
              }}
            >
              Recently viewed ({getallmerger?.count?.viewed_count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "savepost" })}
              onClick={() => {
                toggle("savepost");
              }}
            >
              Saved Companies ({getallmerger?.count?.wishlist_count || 0})
            </NavLink>
          </NavItem>
        </Nav>
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <FilterAll />
          </div>
          <AllMergersAcquisition theactiveTab={activeTab} />
        </div>
      </div>
    </div>
  );
}
